import { useEffect, useRef } from "react";

const SHORTCUTS = [
  [["j", "↓"], "Επόμενη υπόθεση"],
  [["k", "↑"], "Προηγούμενη υπόθεση"],
  [["Enter"], "Άνοιγμα στο πλαίσιο"],
  [["o", "Shift+Enter"], "Άνοιγμα σε πλήρη σελίδα"],
  [["/"], "Αναζήτηση"],
  [["Esc"], "Έξοδος από αναζήτηση / κλείσιμο πλαισίου / καθαρισμός επιλογής"],
  [["x"], "Επιλογή υπόθεσης"],
  [["s"], "Σημαντικό"],
  [["r"], "Έλεγχος τώρα"],
  [["[", "]"], "Προηγούμενη / επόμενη σελίδα"],
  [["?"], "Αυτή η λίστα"],
];

const ShortcutsHelp = ({ onClose }) => {
  const closeRef = useRef(null);

  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (e) => {
      if (e.key === "Escape" || e.key === "?") {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }
    };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
  }, [onClose]);

  return (
    <div className="ds-modal-backdrop" data-ds-modal-open="true" onMouseDown={onClose}>
      <div
        className="ds-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ds-shortcuts-title"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="ds-modal-header">
          <h2 id="ds-shortcuts-title">Συντομεύσεις πληκτρολογίου</h2>
          <button ref={closeRef} type="button" className="ds-link-btn" onClick={onClose}>
            Κλείσιμο
          </button>
        </div>
        <dl className="ds-shortcuts">
          {SHORTCUTS.map(([keys, label]) => (
            <div key={label} className="ds-shortcut-row">
              <dt>
                {keys.map((k) => (
                  <kbd key={k} className="ds-kbd">
                    {k}
                  </kbd>
                ))}
              </dt>
              <dd>{label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
};

export default ShortcutsHelp;
